import React from "react";
import styled from "../style.module.css";

// The "30-second view" — a few headline numbers in a prominent band.
// `items` = [{ label, value, accent, hint }]; first item is the largest.
const HeroSummary = ({ items }) => (
  <div className={styled.heroSummary}>
    {items.map((it, i) => (
      <div key={i} className={`${styled.heroItem} ${i === 0 ? styled.heroItemLead : ""}`} style={{ "--accent": it.accent }}>
        <span className={styled.heroLabel}>{it.label}</span>
        <span className={styled.heroValue}>{it.value}</span>
        {it.hint && <span className={styled.heroHint}>{it.hint}</span>}
      </div>
    ))}
  </div>
);

export default HeroSummary;
